<h2>Umsjónarsíða 
    <button *ngIf="resetAvailable" mat-icon-button matTooltip="Skrá nýtt skilríki" matTooltipPosition="after" (click)="resetForm()">
        <mat-icon>redo</mat-icon>
    </button>
</h2>
<div class="divider"></div>
<app-certificate-request-form (submitComplete)="resetAvailable = true"></app-certificate-request-form>